class Facebook {
    load = (appId) => {
        return new Promise((resolve) => {
            if (!window.FB) {
                const script = document.createElement('script');
                script.src = 'https://connect.facebook.net/en_US/sdk.js';
                script.async = true;
                script.onload = () => {
                    this.init(appId).then(() => {
                        resolve();
                    });
                };
                document.body.appendChild(script);
            }
            resolve();
        });
    };

    init = (appId) => {
        return new Promise((resolve) => {
            window.FB.init({
                appId,
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v3.2'
            });
            resolve();
        });
    };

    signIn() {
        const fb = window.FB;

        return new Promise((resolve, reject) => {
            fb.getLoginStatus((response) => {
                if (response.status === 'connected') {
                    resolve(response.authResponse);
                }

                fb.login((loginResponse) => {
                    if (!loginResponse || !loginResponse.authResponse) {
                        reject();
                    }
                    const accessToken = loginResponse.authResponse.accessToken;
                    const expiresIn = loginResponse.authResponse.expiresIn;
                    const authObject = {
                        accessToken,
                        expiresIn
                    };
                    resolve(authObject);
                },
                {
                    // the authorized scopes
                    scope: 'email'
                });
            });
        });
    }

    getUserObject() {
        const fb = window.FB;

        return new Promise((resolve) => {
            fb.api('/me?fields=id,name,email', (response) => {
                const username = response.name.replace(/\s/g, '');
                const id = response.id;
                const user = {
                    id,
                    username
                };
                resolve(user);
            });
        });
    }
}

const instance = new Facebook();

export default instance;
